import React, { SVGProps } from "react";

const SvgRoof4 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 350 300"
    {...props}
  >
    <defs>
      <linearGradient
        id="roof4_svg__c"
        x1={168.737}
        y1={206.564}
        x2={144.787}
        y2={165.081}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.443} stopColor="#b4c5d3" stopOpacity={0} />
        <stop offset={1} stopColor="#b4c5d3" stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="roof4_svg__a"
        x1={55.615}
        y1={198.395}
        x2={103.003}
        y2={116.317}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.316} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="roof4_svg__d"
        x1={295.319}
        y1={176.8}
        x2={247.157}
        y2={93.381}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.342} stopColor="#b4c5d3" stopOpacity={0} />
        <stop offset={1} stopColor="#b4c5d3" stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="roof4_svg__e"
        x1={212.512}
        y1={213.786}
        x2={212.512}
        y2={134.983}
        xlinkHref="#roof4_svg__a"
      />
      <linearGradient
        id="roof4_svg__b"
        x1={330.709}
        y1={114.557}
        x2={330.709}
        y2={91.658}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.117} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="roof4_svg__f"
        x1={231.1}
        y1={181}
        x2={231.1}
        y2={158.101}
        xlinkHref="#roof4_svg__b"
      />
      <linearGradient
        id="roof4_svg__g"
        x1={193.925}
        y1={160.087}
        x2={193.925}
        y2={137.189}
        xlinkHref="#roof4_svg__b"
      />
      <linearGradient
        id="roof4_svg__h"
        x1={20.139}
        y1={145.679}
        x2={20.139}
        y2={112.401}
        xlinkHref="#roof4_svg__b"
      />
      <linearGradient
        id="roof4_svg__i"
        x1={119.429}
        y1={202.871}
        x2={119.429}
        y2={179.973}
        xlinkHref="#roof4_svg__b"
      />
    </defs>
    <path fill="none" d="M0 0h350v300H0z" />
    <path
      fill="url(#roof4_svg__c)"
      d="M119.598 179.735v55.199l74.327-43.024v-55.199l-74.327 43.024z"
    />
    <path
      fill="url(#roof4_svg__a)"
      d="M119.487 179.939v55.199l-99.289-57.191v-65.58l44.628-18.091 54.661 85.663z"
    />
    <path
      fill="url(#roof4_svg__d)"
      d="M231.1 154.188v59.598l99.609-57.418v-66.49l-45.568-18.427-54.041 82.737z"
    />
    <path
      fill="url(#roof4_svg__e)"
      d="M231.1 154.188v59.598l-37.175-21.648v-57.155l37.175 19.205z"
    />
    <g fill="#6d9faf">
      <path d="M68.65 116.138v10.016l-8.328-4.797v-10.016l8.328 4.797zM78.851 122.027v10.016l-8.328-4.797V117.23l8.328 4.797zM68.65 128.133v10.016l-8.328-4.796v-10.016l8.328 4.796zM78.851 134.023v10.016l-8.328-4.797v-10.016l8.328 4.797z" />
    </g>
    <path
      fill="#237aad"
      d="m194.052 136.641-74.565 43.298L64.322 94.55l129.731-74.835-.001 116.926z"
    />
    <path
      fill="#46d5ff"
      d="M194.053 19.715 64.322 94.55l-54.263 21.951 183.994-106.42v9.634z"
    />
    <path
      fill="#2681b6"
      d="m194.053 19.715-.001-9.645 109.479 63.538L340 94.708l-54.038-21.827-91.909-53.166z"
    />
    <path
      fill="#4df2ff"
      d="m194.053 19.715-.001 116.926 37.064 21.46 54.846-85.22-91.909-53.166z"
    />
    <path
      fill="none"
      stroke="#002839"
      strokeLinejoin="round"
      d="m194.053 10.081-.128 126.63"
    />
    <path fill="url(#roof4_svg__b)" d="M330.209 91.658h1v22.898h-1z" />
    <path fill="url(#roof4_svg__f)" d="M230.6 158.101h1v22.898h-1z" />
    <path fill="url(#roof4_svg__g)" d="M193.425 137.189h1v22.898h-1z" />
    <path fill="url(#roof4_svg__h)" d="M19.639 112.401h1v33.278h-1z" />
    <path fill="url(#roof4_svg__i)" d="M118.929 179.973h1v22.898h-1z" />
    <path
      fill="none"
      stroke="#002839"
      strokeMiterlimit={10}
      d="m64.4 94.034 129.649-74.316M286.287 72.504 194.05 19.719"
    />
    <path
      fill="none"
      stroke="#002839"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m193.925 136.711-74.496 43.262-55.166-85.389L10 116.535 194.335 10 340 94.708l-53.713-22.204-55.171 85.597-37.191-21.39z"
    />
  </svg>
);

export default SvgRoof4;
